import {BaseWidgetSettings} from "./base-settings.type";
import {ContentfulSettings} from "./contentful-settings.type";
import {ComponentVariant} from "./component-variants";



export type BreadcrumbsWidgetSettings = {
  variant?: ComponentVariant;
} & BaseWidgetSettings & ContentfulSettings;
